module.exports = __webpack_public_path__ + "img/youtube.e78eead3.png";